/**
 * Fire the browser's print for the receipt only. Scopes the print to the
 * `#receipt-print` element via the `.printing-receipt` class on <html> (see the
 * thermal print rules in index.css), then clears it on `afterprint` with a
 * timeout fallback.
 *
 * Prints SILENTLY (no dialog) when Chrome runs with --kiosk-printing and the
 * thermal printer is the default; otherwise the normal print dialog opens.
 */
export function printReceipt(): void {
  if (typeof window === 'undefined') return;
  const root = document.documentElement;
  root.classList.add('printing-receipt');
  const cleanup = () => {
    root.classList.remove('printing-receipt');
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);
  window.print();
  setTimeout(cleanup, 1500);
}
